import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import COMPANIES_CONTROLLER from '../../controllers/companies';
import CONTENT_CONTROLLER from '../../controllers/content';
import MANAGED_UX_FORMS_CONTROLLER from '../../controllers/managedUxForms';
import LANGUAGES_CONTROLLER from '../../controllers/languages';
import CompanyBlank from './BlankForms/Company.json';
import CompanyForm from './CompanyForm';
import ApplicationMessages from '../inAppMessages/ApplicationMessages';
import Logger, {LOG_LEVELS,ALL_MESSAGES} from '../../utils/logger';
import _ from "underscore";
import QueryString from "query-string";
import UK_MTD_VAT_CONTROLLER from "../../controllers/ukMTDVAT";
import ReactTable from "react-table";
import Pagination from '../page/Pagination';
import Modal from 'react-responsive-modal';
import VATNumberForm from './VATNumberForm';
import VATNumberBlank from './BlankForms/VATNumber.json';
import LanguageStringResolver from '../fields/language/LanguageStringResolver';
import UploadModal from '../modals/UploadModal';
import FileSaveAs from '../downloaders/FileSaveAs';
import AuthorizedResource from '../authorization/AuthorizedResource';
import ReadOnlyWrapper from '../authorization/ReadOnlyWrapper';
import authorize from '../../utils/auth';
import ConfirmationModal from '../modals/ConfirmationModal';
import CompaniesTable from './CompaniesTable';

const FORM_NAME = 'COMPANY_PAGE';
const log = new Logger(FORM_NAME, LOG_LEVELS.DEBUG);
const FILTER_PANEL_DISMISS_BLOCK_MS = 500;
const VAT_NUMBER_DEEP_LINK_SESSION_KEY = 'companiesPage:vatNumberDeepLink';
const VAT_NUMBER_DEEP_LINK_STASH_MAX_AGE_MS = 5 * 60 * 1000;

export const caseInsensitiveContains = (filter, row) =>
  String(row[filter.id] == null ? '' : row[filter.id]).toLowerCase()
    .includes(String(filter.value == null ? '' : filter.value).toLowerCase());

function parseQueryParams(string) {
    const originalQp =  QueryString.parse(string, {arrayFormat: 'index'});
    return _.each(originalQp, (value, key) => {return decodeURIComponent(value)});
}

const VATNumberActionsCell = ({ original, onDeleteVATNumber }) => {
  return (
    <ReadOnlyWrapper>
      <div>
        <button className="link tertiary" onClick={() => onDeleteVATNumber(original)}>
          <LanguageStringResolver string='companiesPage_DeleteVATNumber'/>
        </button>
      </div>
    </ReadOnlyWrapper>
  );
};
export class Page extends Component {

  constructor(props) {
    super(props);
    this.state = {
      openVATNumbers: false,
      openAddVATNumbers: false,
      openEditCompany: false,
      openUploadModal: false,
      companyName: '',
      vatNumbers: [],
      company: {},
      companyCode: '',
      companyId:0,
      removeExistingCompanies: false,
      showDeleteCompanyConfirmationModal: false,
      companyIdToDelete: -1,
      showDeleteAllCompaniesConfirmationModal: false,
      toggleFilterPanel: true,
      shouldRestoreFilterPanelOpen: false,
      expandedVATNumberRows: {},
      vatNumberModalFilters: []
    };
    this.onOpenVATNumbersModal = this.onOpenVATNumbersModal.bind(this);
    this.onCloseVATNumbersModal = this.onCloseVATNumbersModal.bind(this);
    this.onOpenAddVATNumbersModal = this.onOpenAddVATNumbersModal.bind(this);
    this.onCloseAddVATNumbersModal = this.onCloseAddVATNumbersModal.bind(this);
    this.onOpenEditCompanyModal = this.onOpenEditCompanyModal.bind(this);
    this.onCloseEditCompanyModal = this.onCloseEditCompanyModal.bind(this);
    this.onUpdateVatNumberHandlerFactory = this.onUpdateVatNumberHandlerFactory.bind(this);
    this.onDeleteVATNumberFactory = this.onDeleteVATNumberFactory.bind(this);
    this.onUploadModalOpen = this.onUploadModalOpen.bind(this);
    this.onUploadModalClose = this.onUploadModalClose.bind(this);
    this.onUploadModalSubmit = this.onUploadModalSubmit.bind(this);
    this.onExportCompaniesData = this.onExportCompaniesData.bind(this);
    this.onDeleteSIICertificateHandle = this.onDeleteSIICertificateHandle.bind(this);
    this.askForDeleteCompanyConfirmation = this.askForDeleteCompanyConfirmation.bind(this);
    this.deleteCompanyConfirmationModalYesHandler= this.deleteCompanyConfirmationModalYesHandler.bind(this);
    this.deleteCompanyConfirmationModalCancelHandler = this.deleteCompanyConfirmationModalCancelHandler.bind(this);
    this.onRemoveExistingCompaniesChange = this.onRemoveExistingCompaniesChange.bind(this);
    this.deleteAllCompaniesConfirmationModalYesHandler = this.deleteAllCompaniesConfirmationModalYesHandler.bind(this);
    this.deleteAllCompaniesConfirmationModalCancelHandler = this.deleteAllCompaniesConfirmationModalCancelHandler.bind(this);
    this.renderVATNumberActionsCell = this.renderVATNumberActionsCell.bind(this);
    this.handleToggleFilterPanel = this.handleToggleFilterPanel.bind(this);
    this.handleFilterPanelDismiss = this.handleFilterPanelDismiss.bind(this);
    this.filterPanelDismissBlockedUntil = 0;
    this.refreshCompaniesOnSiiCertDataChange = false;
  }

  isCompaniesOverlayOpen() {
    const {
      openVATNumbers,
      openAddVATNumbers,
      openEditCompany,
      openUploadModal,
      showDeleteCompanyConfirmationModal,
      showDeleteAllCompaniesConfirmationModal
    } = this.state;

    return Boolean(
      openVATNumbers ||
      openAddVATNumbers ||
      openEditCompany ||
      openUploadModal ||
      showDeleteCompanyConfirmationModal ||
      showDeleteAllCompaniesConfirmationModal
    );
  }

  closeCompaniesOverlay(stateUpdate, shouldBlockFilterDismiss = false) {
    if (shouldBlockFilterDismiss) {
      this.filterPanelDismissBlockedUntil = Date.now() + FILTER_PANEL_DISMISS_BLOCK_MS;
    }
    this.setState(stateUpdate);
  }

  handleFilterPanelDismiss() {
    if (this.isCompaniesOverlayOpen() || Date.now() < this.filterPanelDismissBlockedUntil) {
      this.setState((prevState) => ({
        toggleFilterPanel: true,
        shouldRestoreFilterPanelOpen: !prevState.shouldRestoreFilterPanelOpen
      }));
      return;
    }

    this.setState({ toggleFilterPanel: false });
  }

  onUploadModalOpen() {
    log.debug("onUploadModalOpen()");
    this.setState({
      openUploadModal: true
    });
  }

  onUploadModalClose() {
    log.debug("onUploadModalClose()");
    this.closeCompaniesOverlay({
      openUploadModal: false
    });
  }

  onUploadModalSubmit(files) {
    log.debug("onUploadModalSubmit()");
    this.setState({
      openUploadModal: false
    });
    const importCompanyOperation = () => {
      this.props.onImportCompanies(files, (error, data) => {
          this.props.onPageLoad();
          this.props.onGetVATNumberRules();
          this.props.onUserLoad();
          this.props.doGetAuthorizationurl();
          this.setState({
            removeExistingCompanies: false
          });         
      });
    };
    log.debug("onUploadModalSubmit(): state.removeExistingCompanies: ", this.state.removeExistingCompanies);
    if(this.state.removeExistingCompanies) {
      const ids = Array.isArray(this.props.companies) ? this.props.companies.map( company => company.id) : [];
      log.debug("onUploadModalSubmit(): Remvoing companies with ids: ", ids)
      this.props.onDeleteCompanies(ids, false, (error, data) => {
        importCompanyOperation();
      });
    } else {
      importCompanyOperation();
    }
  }

  onRemoveExistingCompaniesChange(checked) {
    if (checked) {
      this.setState({ showDeleteAllCompaniesConfirmationModal: true });
    } else {
      this.setState({ removeExistingCompanies: false });
    }
  }

  deleteAllCompaniesConfirmationModalYesHandler() {
    this.setState({
      showDeleteAllCompaniesConfirmationModal: false,
      removeExistingCompanies: true
    });
  }

  deleteAllCompaniesConfirmationModalCancelHandler() {
    this.closeCompaniesOverlay({
      showDeleteAllCompaniesConfirmationModal: false,
      removeExistingCompanies: false
    });
  }

  onExportCompaniesData() {
    log.debug('onExportCompaniesData()');
      return new Promise((resolve, reject) => {
        this.props.doExportCompanies( (err, data) => {
          if(err) {
            reject(err);
            return;
          }         
          const downloadData = {
            content: data || '',
            ext: 'xml'
          };          
          resolve(downloadData);
        });
      });
  }

  onOpenVATNumbersModal(original) {
    log.debug("onOpenVATNumbersModal()", original);
    let company = {};
    //loading details each time as need to fetch updated 'vatNumberTechnicalCheck' and 'vatNumberUKMTDAuthorize'
    this.props.doLoadCompanyDetails(original.id, ()=>{
      company = this.props.companiesDetails.get(original.id.toString());
      this.setState({ openVATNumbers: true, companyName: company.name, companyCode: company.code, companyId:company.id, vatNumbers: company.vatNumbers });
    });  
    this.props.doClearAllErrors();  
    this.refreshCompaniesOnSiiCertDataChange = false;
  }

  onCloseVATNumbersModal() {
    this.closeCompaniesOverlay({
      openVATNumbers: false,
      companyName: '',
      expandedVATNumberRows: {},
      vatNumberModalFilters: []
    });
    this.clearStashedVATNumberDeepLink();

      if(this.refreshCompaniesOnSiiCertDataChange ){
       // Why to reload companies data ?
       // This logic is comes into picture when country is selected as SPAIN(ES),
       // There are two condition the companied data will be reloaded. this operation is managed by refreshCompaniesOnSiiCertDataChange flag
       // 1.	On ES Immediate Filing(SII),when Delete certificate is done by user. 
       //     It will call DELETE Certificate endpoint, so we need to refresh companies data 
       //     because delete will update Thumbprint to blank.
       //     However we can not refresh companies data immediately because we need to keep Model popup Open for user to do further operation like update new certificate .
       //     Hence once model popup closed we are refreshing companies.
       // 2.	When user tried to SAVE certificate and SAVE procedure errored out ,
       //     in this case we are keeping model pop up open for showing error message. Hence immediate company data refresh is not possible, Hence once model popup closed we are refreshing companies.
        
          this.props.onPageLoad();
      }
  }

  onOpenAddVATNumbersModal(original){
    log.debug('onOpenAddVATNumbersModal()', original)
    let company = {};
    if(this.props.companiesDetails && this.props.companiesDetails.has(original.id.toString()))
    {
      company = this.props.companiesDetails.get(original.id.toString());
      this.setState({ openAddVATNumbers: true, companyCode: original.code, companyId:original.id});
    }
    else
    {
      this.props.doLoadCompanyDetails(original.id, ()=>{
          company = this.props.companiesDetails.get(original.id.toString());
          this.setState({ openAddVATNumbers: true, companyCode: original.code, companyId:original.id});
      });  
    }   
    this.props.doClearAllErrors();
    log.debug('companyCode', this.state.companyCode)
  }

  onCloseAddVATNumbersModal () {
    this.closeCompaniesOverlay({ openAddVATNumbers: false });
  }

  handleToggleFilterPanel() {
    this.setState({ toggleFilterPanel: !this.state.toggleFilterPanel });
  }

  onOpenEditCompanyModal (original) {  
    log.debug("onOpenEditCompanyModal()", original);
    let company = {};
    if(this.props.companiesDetails && this.props.companiesDetails.has(original.id.toString()))
    {
      company = this.props.companiesDetails.get(original.id.toString());
      this.setState({ openEditCompany: true, company: company});
    }
    else
    {
      this.props.doLoadCompanyDetails(original.id, ()=>{
          company = this.props.companiesDetails.get(original.id.toString());
          this.setState({ openEditCompany: true, company: company});
      });  
    } 
    this.props.doClearAllErrors();
  }

  onCloseEditCompanyModal(){
    log.clearAllDictionaryErrors();
    this.closeCompaniesOverlay({
      openEditCompany: false
    }, true);
  }

  UNSAFE_componentWillMount() {
    this.props.onPageLoad();
    this.props.onGetVATNumberRules();
    this.props.onUserLoad();
    this.props.doGetAuthorizationurl();
      log.debug('componentWillMount(): ', this.props);
  }  

  componentDidMount() {
    log.debug('componentDidMount()');
    log.clearAllDictionaryErrors();
      log.debug('componentDidMount()');
      const parsedQueryParams = parseQueryParams(this.props.location.search);
      log.debug('componentDidMount() parsedQueryParams', parsedQueryParams);
      if(parsedQueryParams.code !== undefined) {
          var seapratorIndex = parsedQueryParams.vatnumber.indexOf('_');
          var vatnumber = parsedQueryParams.vatnumber.substr(0,seapratorIndex);
          var companyCode = parsedQueryParams.vatnumber.substr(seapratorIndex + 1,(parsedQueryParams.vatnumber.length - seapratorIndex));
          log.debug('componentDidMount() vatnumber', vatnumber,companyCode);
          // The authorisation code is single-use: drop it from the URL so a remount or reload cannot resend it.
          this.scrubDeepLinkUrl(['code', 'vatnumber']);
          this.props.doGenerateToken(parsedQueryParams.code, vatnumber, companyCode,
              () => {
                  log.clearDictionaryError(ALL_MESSAGES.MTD_AUTH_FAILED);
                  log.setDictionaryMessage(ALL_MESSAGES.MTD_AUTH_SUCCESS);
              },
              () => {
                  log.clearDictionaryError(ALL_MESSAGES.MTD_AUTH_SUCCESS);
                  log.setDictionaryMessage(ALL_MESSAGES.MTD_AUTH_FAILED);
              });
      }
      else if(parsedQueryParams.error_description !== undefined)
      {
          log.clearDictionaryError(ALL_MESSAGES.MTD_AUTH_SUCCESS);
          log.setDictionaryMessage(ALL_MESSAGES.MTD_AUTH_FAILED);
      }
      else if(parsedQueryParams.companyId !== undefined)
      {
          log.clearDictionaryError(ALL_MESSAGES.MTD_AUTH_FAILED);
          log.clearDictionaryError(ALL_MESSAGES.MTD_AUTH_SUCCESS);
          this.handleVATNumberDeepLink(parsedQueryParams);
      }
      else
      {
          log.clearDictionaryError(ALL_MESSAGES.MTD_AUTH_FAILED);
          log.clearDictionaryError(ALL_MESSAGES.MTD_AUTH_SUCCESS);
          this.resumeStashedVATNumberDeepLink();
      }
  }

  // Deep-link entry: open the VAT Numbers modal for the requested company, and, when a
  // specific vatNumber is also given, pre-filter and expand its row.
  handleVATNumberDeepLink(parsedQueryParams) {
      const targetCompanyId = Number(parsedQueryParams.companyId);
      const targetVatNumber = parsedQueryParams.vatNumber;
      this.scrubDeepLinkUrl(['companyId', 'vatNumber']);
      if (Number.isNaN(targetCompanyId)) {
          log.setDictionaryMessage(ALL_MESSAGES.INVALID_DEEP_LINK_INFO);
          return;
      }
      this.stashVATNumberDeepLink(targetCompanyId, targetVatNumber);
      this.loadAndOpenVATNumberModal(targetCompanyId, targetVatNumber, false);
  }

  resumeStashedVATNumberDeepLink() {
      const stashed = this.readStashedVATNumberDeepLink();
      if (!stashed) {
          return;
      }
      this.loadAndOpenVATNumberModal(stashed.companyId, stashed.vatNumber, true);
  }

  loadAndOpenVATNumberModal(targetCompanyId, targetVatNumber, isResume) {
      this.props.doLoadCompanyDetails(targetCompanyId, () => {
          const company = this.props.companiesDetails && this.props.companiesDetails.get(targetCompanyId.toString());
          if (!company) {
              if (isResume) {
                  this.clearStashedVATNumberDeepLink();
              }
              log.setDictionaryMessage(ALL_MESSAGES.INVALID_DEEP_LINK_INFO);
              return;
          }
          const vatNumbers = company.vatNumbers || [];
          const targetEntry = targetVatNumber
              ? vatNumbers.find((v) => v.vatnumber === targetVatNumber)
              : undefined;
          if (targetVatNumber && !targetEntry) {
              if (isResume) {
                  this.clearStashedVATNumberDeepLink();
              }
              log.setDictionaryMessage(ALL_MESSAGES.INVALID_DEEP_LINK_INFO);
              return;
          }
          const vatNumberModalFilters = targetEntry
              ? [
                  { id: 'vatnumberCountry', value: targetEntry.vatnumberCountry },
                  { id: 'vatnumber', value: targetEntry.vatnumber }
                ]
              : [];
          this.setState({
              openVATNumbers: true,
              companyName: company.name,
              companyCode: company.code,
              companyId: company.id,
              vatNumbers: vatNumbers,
              vatNumberModalFilters: vatNumberModalFilters,
              expandedVATNumberRows: targetEntry ? { 0: {} } : {}
          });
      });
  }

  // Removes only the given single-use params; other params (e.g. customerId) must survive.
  scrubDeepLinkUrl(keys) {
      if (this.props.history && typeof this.props.history.replace === 'function') {
          const params = new URLSearchParams(this.props.location.search);
          keys.forEach(key => params.delete(key));
          const search = params.toString();
          this.props.history.replace({ pathname: this.props.location.pathname, search: search ? `?${search}` : '', hash: this.props.location.hash });
      }
  }

  stashVATNumberDeepLink(companyId, vatNumber) {
      try {
          sessionStorage.setItem(VAT_NUMBER_DEEP_LINK_SESSION_KEY, JSON.stringify({ companyId, vatNumber, stashedAt: Date.now() }));
      } catch (error) {
          log.debug('stashVATNumberDeepLink(): failed to write to sessionStorage', error);
      }
  }

  readStashedVATNumberDeepLink() {
      let raw;
      try {
          raw = sessionStorage.getItem(VAT_NUMBER_DEEP_LINK_SESSION_KEY);
      } catch (error) {
          log.debug('readStashedVATNumberDeepLink(): failed to read from sessionStorage', error);
          return null;
      }
      if (!raw) {
          return null;
      }
      try {
          const stashed = JSON.parse(raw);
          const age = Date.now() - stashed.stashedAt;
          if (!Number.isFinite(stashed.companyId) || !(age >= 0 && age <= VAT_NUMBER_DEEP_LINK_STASH_MAX_AGE_MS)) {
              this.clearStashedVATNumberDeepLink();
              return null;
          }
          return stashed;
      } catch (error) {
          log.debug('readStashedVATNumberDeepLink(): failed to parse stashed value', error);
          this.clearStashedVATNumberDeepLink();
          return null;
      }
  }

  clearStashedVATNumberDeepLink() {
      try {
          sessionStorage.removeItem(VAT_NUMBER_DEEP_LINK_SESSION_KEY);
      } catch (error) {
          log.debug('clearStashedVATNumberDeepLink(): failed to remove from sessionStorage', error);
      }
  }
    updateCompany(company) {
        log.debug('updateCompany(): ', company);
       this.setState({ openEditCompany: false });
        this.props.onUpdateCompany(company.id, company);       
        //Scroll to top
        window.scrollTo(0, 0);
    }
    updateCompanyWithEsSIICertificate(company,esSIICertificateDetails) {
      log.debug('doUpdateWithEsSIICertificate(): ', company);
      this.props.doUpdateWithEsSIICertificate(company.id, company,esSIICertificateDetails,()=>{
        this.refreshCompaniesOnSiiCertDataChange = false;
        this.onCloseVATNumbersModal();
        this.setState({ openEditCompany: false });
        window.scrollTo(0, 0);
      },()=>{
        this.refreshCompaniesOnSiiCertDataChange = true;
      });
    }

    createCompany(company) {
        log.debug('createCompany(): ', company);
        this.props.onCreateCompany(company);        
        //Scroll to top
        window.scrollTo(0, 0);
    }

    deleteCompanyWithoutConfirmation(companyId) {      
      log.debug('deleteCompany(): ', companyId);
      this.props.doClearAllErrors();
      log.clearAllDictionaryErrors();
      this.setState({ openEditCompany: false });
      this.props.onDeleteCompany(companyId);        
      //Scroll to top
      window.scrollTo(0, 0);
    }

    askForDeleteCompanyConfirmation(companyId) {      
        this.setState({
          showDeleteCompanyConfirmationModal: true,
          companyIdToDelete: companyId
        });
    }

    deleteCompanyConfirmationModalYesHandler() {
      this.setState({
        showDeleteCompanyConfirmationModal: false
      });
      this.props.onDeleteCompany(this.state.companyIdToDelete);
    }

    deleteCompanyConfirmationModalCancelHandler() {
      this.closeCompaniesOverlay({
        showDeleteCompanyConfirmationModal: false,
        companyIdToDelete: -1
      });
    }

    onDeleteVATNumberFactory(originalVatNumber, cb) {
      let deleteVATNumbers = () => {
        let company = {};     
        if(this.props.companiesDetails && this.props.companiesDetails.has(this.state.companyId.toString()))
          company = this.props.companiesDetails.get(this.state.companyId.toString());
      
        const vatNumbers = company && company.vatNumbers || [];
        // Create a deep clone of the vatNumbers to update.
        let deletedVatNumbers = JSON.parse(JSON.stringify(vatNumbers));
        const index = deletedVatNumbers.findIndex((entry) => {return entry.vatnumber === originalVatNumber.vatnumber});
        if (index >= 0) {
            const result = deletedVatNumbers.splice(index,1);
            const formNameForCompany = FORM_NAME+'_FOR_'+this.state.companyCode;
            log.debug('formNameForCompany', formNameForCompany);
            // re-construct a full company object from the companyWithoutVatNumbers, and the supplied (updated) vatNumbers
            // and use that to submit (save) the whole company.
            this.updateCompany(Object.assign({}, company, {vatNumbers: deletedVatNumbers}));
        }
        if(typeof cb === 'function') {
          cb();
        }
      };
      return deleteVATNumbers.bind(this);
    }
    onDeleteSIICertificateHandle(){
      this.refreshCompaniesOnSiiCertDataChange = true;
    }

    renderVATNumberActionsCell({ original }) {
      return (
        <VATNumberActionsCell
          original={original}
          onDeleteVATNumber={this.onDeleteVATNumberFactory(original, () => {this.onCloseVATNumbersModal();})}
        />
      );
    }

    // Using a factory here to preserve knowledge of the original VAT Number.
    // This will allows the vatNumber in the form to be changed, and we update the correct entry, not create a new one by accident
    onUpdateVatNumberHandlerFactory(originalVatNumber={}, cb=()=>{}) {
      let updateVATNumbersFields = (vatNumberFields,esSIICertificatePresent,esSIICertificateDetails) => {
        log.debug('onUpdateVatNumberHandlerFactory(%s): ', originalVatNumber, vatNumberFields);

        let company = {};     
        if(this.props.companiesDetails && this.props.companiesDetails.has(this.state.companyId.toString()))
          company = this.props.companiesDetails.get(this.state.companyId.toString());        

        const vatNumbers = company && company.vatNumbers || [];
        // Create a deep clone of the vatNumbers to update.
        let updatedVatNumbers = JSON.parse(JSON.stringify(vatNumbers));
        const index = updatedVatNumbers.findIndex((entry) => {return entry && originalVatNumber && entry.vatnumber === originalVatNumber.vatnumber});
        // If we found a entry which has the original vat number, replace it with the new fields,
        // otherwise add the fields to the end of the array.
        if (index >= 0) {
          updatedVatNumbers[index] = vatNumberFields;
        }
        else {
          updatedVatNumbers.push(vatNumberFields);
        }

        if(esSIICertificatePresent){
          //When country selected is SPAIN(ES) then we have extra tab for ES Immediate Filing(SII) ,where sii certificate file will be uploaded and saved to database ,this action will happen on SAVE VAT Number button.
          //This esSIICertificateDetails data has been passed from SiiSetUp.jsx component to parent(VatNumberForm.jsx),from parent to this grandparent component (page.jsx) 
          //This updateCompanyWithEsSIICertificate will save company data and certificate data as well.
          log.clearAllDictionaryErrors();
          this.updateCompanyWithEsSIICertificate(Object.assign({}, company, {vatNumbers: updatedVatNumbers}),esSIICertificateDetails);
        }else{
          this.updateCompany(Object.assign({}, company, {vatNumbers: updatedVatNumbers}));
          if(typeof cb === 'function') {
            cb();
          }
        }
       
      };
      return updateVATNumbersFields.bind(this);
    }

  render() {
    log.debug('render(): ', this.props);
    const { openVATNumbers } = this.state;
    const { openAddVATNumbers } = this.state;
    const { openEditCompany } = this.state;

    const modal_columns = [
      {
        expander: true,
        Header: () => <span><LanguageStringResolver string='companiesPage_Edit'/></span>,
        width: 65,
        Expander: ({ isExpanded, ...rest }) =>
            <s-icon name="chevron-down"></s-icon>,
        style: {
          cursor: "pointer",
          padding: "0",
          textAlign: "center",
          userSelect: "none"
        }
      },{
      Header: () => <span><LanguageStringResolver string='companiesPage_Country'/></span>,
      accessor: 'vatnumberCountry',
      filterable:true,
      filterMethod: caseInsensitiveContains
    },{
      Header: () => <span><LanguageStringResolver string='companiesPage_VATNumber'/></span>,
      accessor: 'vatnumber',
      filterable:true,
      filterMethod: caseInsensitiveContains
    },{
      accessor: "SendingEnabled",
      Header: () => (<span><LanguageStringResolver string='companiesPage_Actions'/></span>),
      Cell: this.renderVATNumberActionsCell
    }]

    const MODAL_CLASSNAMES =  {
      modal: 'modal-full-width-height modal-max-width-85 pb0'
    };

    return (
        <div className="content-area" data-test="component-companies-page">
          <div className="clear"></div>
          <s-container>
            <ReadOnlyWrapper>
              <h1>{LANGUAGES_CONTROLLER.format(this.props.languages, 'TitleCompanies')}</h1>
                <ApplicationMessages scopes={[FORM_NAME]} messageType="applicationError"/>
                <ApplicationMessages scopes={[FORM_NAME]} messageType="applicationSuccess" className="mt0 mb0" />
                <ApplicationMessages messageType="applicationWarning" messageIds={[ALL_MESSAGES.DUPLICATE_COMPANY_CODE, ALL_MESSAGES.COMPANIES_IMPORT_FAILED, ALL_MESSAGES.INVALID_DEEP_LINK_INFO]}/>
                <ApplicationMessages messageType="applicationError" 
                  messageIds={[ALL_MESSAGES.VIRUS_SCAN_FAILED,
                    ALL_MESSAGES.FILE_IMPORT_ERROR_EXTENSION_FORBIDDEN,
                    ALL_MESSAGES.FILE_IMPORT_ERROR_EXTENSION_TOO_LONG,
                    ALL_MESSAGES.FILE_IMPORT_ERROR_FILENAME_TOO_LONG,
                    ALL_MESSAGES.FILE_IMPORT_ERROR_FILENAME_FORBIDDEN,
                    ALL_MESSAGES.FILE_IMPORT_ERROR_CONTENTTYPE_FORBIDDEN,
                    ALL_MESSAGES.FILE_IMPORT_ERROR_CONTENTTYPE_MISMATCH]}
                  />
                <ApplicationMessages messageType="applicationSuccess" messageIds={[ALL_MESSAGES.COMPANIES_IMPORTED_SUCCESSFULLY]}/>
                <div className="toggle-container">
                  <h2 className="pb15">{LANGUAGES_CONTROLLER.format(this.props.languages, 'company_ExistingCompanies')}</h2>
                  <div className="companies-table-section">
                    <s-row>
                      <s-col span="6">
                        <button
                          className={this.state.toggleFilterPanel ? "toggle-button icon-leading mt10" : "secondary icon-leading mt10"}
                          data-testid="companies-filter-button"
                          onClick={this.handleToggleFilterPanel}
                        >
                          <s-icon name="filter" />
                          <LanguageStringResolver string="FilterButton" />
                        </button>
                      </s-col>
                    </s-row>
                    <CompaniesTable
                      shouldRestoreFilterPanelOpen={this.state.shouldRestoreFilterPanelOpen}
                      companies={this.props.companies || []}
                      languages={this.props.languages}
                      toggleFilterPanel={this.state.toggleFilterPanel}
                      onFilterPanelDismiss={this.handleFilterPanelDismiss}
                      onOpenVATNumbers={this.onOpenVATNumbersModal}
                      onOpenAddVATNumbers={this.onOpenAddVATNumbersModal}
                      onOpenEditCompany={this.onOpenEditCompanyModal}
                      onDeleteCompany={this.askForDeleteCompanyConfirmation}
                    />
                  </div>

                  {/* Start of view VAT numbers modal */}
                  <Modal
                    classNames={MODAL_CLASSNAMES}
                    open={openVATNumbers}
                    onClose={this.onCloseVATNumbersModal}
                    center
                  >
                    <h2><LanguageStringResolver string='companiesPage_VATNumberFor'/> {this.state.companyName}</h2>
                    <ReactTable
                      defaultPageSize={20}
                      minRows={0}
                      maxRows={0}
                      data={this.state.vatNumbers}
                      columns={modal_columns}
                      className="no-bg"
                      PaginationComponent={Pagination}
                      filtered={this.state.vatNumberModalFilters}
                      onFilteredChange={(filtered) => this.setState({ vatNumberModalFilters: filtered })}
                      expanded={this.state.expandedVATNumberRows}
                      onExpandedChange={(expanded) => this.setState({ expandedVATNumberRows: expanded })}
                      SubComponent={row => {
                        log.debug('VATNumbersRProps(): ', this.props);
                        log.debug('VATNumbersRow(): ', row);
                        log.debug('this.state.companyCode():', this.state.companyCode)
                        log.debug('VATNumberDetails(): ', row.original.vatnumber, this.state.companyCode);
                        return (
                          <div style={{ padding: "20px" }}>
                            <h2><LanguageStringResolver string='companiesPage_editVATNumber'/></h2>
                          <VATNumberForm
                              companyCode={this.state.companyCode}
                              vatNumber={row.original}
                              onDeleteSIICertificateHandle = {this.onDeleteSIICertificateHandle}
                              submitHandler={this.onUpdateVatNumberHandlerFactory(row.original, ()=>{
                                this.onCloseVATNumbersModal();
                              })}
                              deleteHandler={this.onDeleteVATNumberFactory(row.original, ()=>{
                                this.onCloseVATNumbersModal();
                              })}
                              isAddMode = {false}
                            />
                          </div>
                        );
                      }}
                    />
                  </Modal>

                  {/* Start of Add VAT numbers modal */}
                  <Modal
                    classNames={MODAL_CLASSNAMES}
                    open={openAddVATNumbers}
                    onClose={this.onCloseAddVATNumbersModal}
                    center
                  >
                    <h2><LanguageStringResolver string='companiesPage_addVATNumber'/></h2>
                    <VATNumberForm
                      companyCode={this.state.companyCode}
                      vatNumber={VATNumberBlank}
                      submitHandler={this.onUpdateVatNumberHandlerFactory(null, () => {
                        this.onCloseAddVATNumbersModal();
                      })} 
                      showDelete={false}  
                      isAddMode = {true}                         
                    />
                  </Modal>

                  {/* Start of Edit company details modal */}
                  <Modal
                    classNames={MODAL_CLASSNAMES}
                    open={openEditCompany}
                    onClose={this.onCloseEditCompanyModal}
                    center
                    MODAL_ATTRIBUTES
                  >
                    <span data-test="edit-company-modal">
                      <CompanyForm
                        company={this.state.company}
                        submitHandler={this.updateCompany.bind(this)}
                        deleteCompanyHandler={this.deleteCompanyWithoutConfirmation.bind(this,this.state.company.id)}
                      />
                    </span>
                  </Modal>

                  <FileSaveAs 
                    downloadLabelKey="companiesPage_ExportCompanies" 
                    fetchContent={this.onExportCompaniesData}
                    filename={`Companies-${moment.utc().format('YYYY-MM-DD')}`}  
                    mimeType="application/xml"
                    charset="utf-8"
                    isBlob={true} 
                    disabled={this.props.companies == null || this.props.companies.length == 0}
                  />
                  <button data-testid="import-companies-button" className="secondary mr10" onClick={this.onUploadModalOpen}>
                    <LanguageStringResolver string='companiesPage_ImportCompanies'/>
                  </button>
                  <span className="display-inline-block">
                    <fieldset>
                      <input 
                        data-testid="delete-all-companies-checkbox"
                        checked={this.state.removeExistingCompanies} 
                        type="checkbox" 
                        onChange={(event) => {
                          this.onRemoveExistingCompaniesChange(event.target.checked);
                        }} 
                      />
                      <label className="checkbox"><LanguageStringResolver string={'companiesPage_DeleteAllExistingCompanies'}/></label>
                    </fieldset>
                  </span>
                  <UploadModal
                    titleKey='companiesPage_ImportCompanies'
                    open={this.state.openUploadModal}
                    onClose={this.onUploadModalClose}
                    onSubmit={this.onUploadModalSubmit}
                    fileTypes='.xml'
                    maxFileSize={5}
                    maxNumberOfFiles={1}
                  />
                <hr /> 
                <div className="mt10 mb10">
                  <CompanyForm
                    company={CompanyBlank}
                    newCompany={true}
                    submitHandler={this.createCompany.bind(this)} />
                  <div className="clear"></div>
                </div>
                <div data-testid="page-confirmation-modal">
                  <ConfirmationModal 
                  isModalPopupOpen={this.state.showDeleteCompanyConfirmationModal}
                  modelTitle = "company_Delete"
                  modelMessage = "companiesPage_deleteCompanyConfirmation"
                  onYesClickHandler = {this.deleteCompanyConfirmationModalYesHandler}
                  onCancelClickHandler = {this.deleteCompanyConfirmationModalCancelHandler}
                  />
                </div>
                <div data-testid="page-delete-all-companies-confirmation-modal">
                  <ConfirmationModal 
                  isModalPopupOpen={this.state.showDeleteAllCompaniesConfirmationModal}
                  modelTitle = "company_Delete"
                  modelMessage = "companiesPage_deleteAllCompaniesConfirmation"
                  onYesClickHandler = {this.deleteAllCompaniesConfirmationModalYesHandler}
                  onCancelClickHandler = {this.deleteAllCompaniesConfirmationModalCancelHandler}
                  />
                </div>
              </div>
            </ReadOnlyWrapper>
          </s-container>
        </div>
    );
  }
}

function mapStateToProps(state, props) {
  log.debug('mapStateToProps(): state & starting props', state, props);
  return {

    languages: state.languages,
    companies: state.companies && state.companies.data,
    companiesDetails: state.companies && state.companies.companiesDetails,
    exportCompaniesData: state.companies && state.companies.exportCompaniesData
  };
}

function mapDispatchersToProps(dispatch) {
  return {
    onPageLoad: (queryParams) => {
      log.debug('onPageLoad: ', queryParams);
      log.debug('doLoadCompaniesSummary()');
      dispatch(COMPANIES_CONTROLLER.doLoadCompaniesSummary());
    }, 
    doLoadCompanyDetails: (id, callback) => {
      log.debug('doLoadCompanyDetails() ', id);
      dispatch(COMPANIES_CONTROLLER.doLoadCompanyDetails(id, callback));
    },
    onUserLoad: () => {
        log.debug('onUserLoad: ');
        dispatch(COMPANIES_CONTROLLER.doLoadContactPersonUsers());
    },
    onGetVATNumberRules : () => {
      log.debug('onGetVATNumberRules: ');
      dispatch(CONTENT_CONTROLLER.getVATNumberRules());
    },
    onCreateCompany: (company) => {
        log.debug('onCreateCompany: ',   company);
        dispatch(COMPANIES_CONTROLLER.doCreate(company));
    },
    onUpdateCompany: (id, company) => {
        log.debug('onUpdateCompany: ', id, company);
        dispatch(COMPANIES_CONTROLLER.doUpdate(id, company));
    },
    doUpdateWithEsSIICertificate: (id, company,esSIICertificateDetails,validHandler, invalidHandler) => {
      log.debug('doUpdateWithEsSIICertificate: ', id, company);
      dispatch(COMPANIES_CONTROLLER.doUpdateWithEsSIICertificate(id, company,esSIICertificateDetails,(response) => {
        validHandler(response);
      },(error) => {
        invalidHandler(error);
        }
      ));
    },
    onDeleteCompany: (id) => {
        log.debug('onDeleteCompany: ', id); 
        dispatch(COMPANIES_CONTROLLER.doClearAllErrors());         
        dispatch(COMPANIES_CONTROLLER.doDelete(id));
    },
    onDeleteCompanies: (ids=[], fetchAfterDelete=true, callback=()=>{}) => {
      log.debug('onDelete: ', ids);
      dispatch(COMPANIES_CONTROLLER.doDeleteMany(ids, fetchAfterDelete, callback));
    },
    onImportCompanies: (uploadData, callback) => {
      log.debug('doImportCompanySettings: ', uploadData);
      dispatch(COMPANIES_CONTROLLER.doImportCompanies(uploadData, callback));
    },
    doGenerateToken: (token,vatnumber,companyCode,onSuccess,onFail) => {
        log.debug('doGenerateToken()');
        dispatch(UK_MTD_VAT_CONTROLLER.doGetAccesstoken(token, vatnumber,companyCode,onSuccess,onFail));
    },
    doFormSubmitted: (formNameForCompany) => {
      dispatch(MANAGED_UX_FORMS_CONTROLLER.doFormSubmitted(formNameForCompany));
      log.debug("onFormSubmit", formNameForCompany)
    },
    doGetAuthorizationurl:() => {
        dispatch(UK_MTD_VAT_CONTROLLER.doGetAuthorizationurl());
    },
    doExportCompanies: (callback=()=>{}) => {
      log.debug("doExportCompanies(): ");        
      dispatch(COMPANIES_CONTROLLER.doExport(callback));
    },
    doClearAllErrors: () => {
      log.debug("doClearAllErrors(): ");
      dispatch(COMPANIES_CONTROLLER.doClearAllErrors());
    }

  }
}

export default  authorize({
  name: 'Companies',
  resource: connect(mapStateToProps, mapDispatchersToProps)(Page)
}, AuthorizedResource, {
  showNotAuthorized: true
});
